// url对应语言和banner图
import US_EU from "~/assets/images/tt/phone-us-eu.png";
import IN from "~/assets/images/tt/phone-in.png";
import JP from "~/assets/images/tt/phone-jp.png";
import SEA from "~/assets/images/tt/phone-sea.png";
import ME from "~/assets/images/tt/phone-me.png";

export interface TtRegion {
  [key: string]: {
    image: string;
    hideHeadRect?: boolean;
  };
}

export const ttRegion: TtRegion = {
  us: {
    image: US_EU
  },
  eu: {
    image: US_EU
  },
  ko: {
    image: US_EU
  },
  in: {
    image: IN,
    hideHeadRect: true
  },
  jp: {
    image: JP
  },
  ja: {
    image: JP
  },
  sea: {
    image: SEA
  },
  tr: {
    image: ME,
    hideHeadRect: true
  },
  mena: {
    image: ME,
    hideHeadRect: true
  },
  il: {
    image: ME,
    hideHeadRect: true
  },

  // SEA图
  id: {
    image: SEA
  },
  ms: {
    image: SEA
  },
  th: {
    image: SEA
  },
  vi: {
    image: SEA
  }
};

export const EURO_COUNTRY_LIST = [
  "AT",
  "BE",
  "BG",
  "HR",
  "CY",
  "CZ",
  "DE",
  "DK",
  "EE",
  "EL",
  "FI",
  "FR",
  "GB",
  "GR",
  "HU",
  "IE",
  "IT",
  "LV",
  "LT",
  "LU",
  "MT",
  "NL",
  "PL",
  "PT",
  "RO",
  "SK",
  "SI",
  "ES",
  "SE",
  "NO",
  "IS",
  "LI"
];

export const event2000Region = ["ko", "eg", "jp", "ja", "tr", "ru"];

const commonTitle =
  "Get a $300 USD credit at sign up | Start advertising on TikTok";
const commonDesc =
  "Get back to business with a $300 USD credit at sign up, then we’ll match your spend up to $2,000 USD. It’s time for your business to make a comeback on TikTok. Learn more.";
const event2000CommonTitle = "Get up to $2,000 in ad credit*. Sign up today";
const event2000CommonDesc =
  "Get your business verified and your spending will be matched 1 to 1 with free ad credit, up to a value of $2,000 USD per business. Credits valid until Dec 31st, 2020.*";

export const event2000FaqI18nKeyMap: Record<string, string> = {
  ko: "faq_a4_p3",
  eg: "faq_a4_p3_eg",
  jp: "faq_a4_p3_jp",
  ja: "faq_a4_p3_jp",
  tr: "faq_a4_p3_tr",
  ru: "faq_a4_p3_ru"
};

export const b2bMetaMap: {
  [region: string]: { title: string; desc: string };
} = {
  default_2000: {
    title: event2000CommonTitle,
    desc: event2000CommonDesc
  },
  default: {
    title: commonTitle,
    desc: commonDesc
  }
};
export const showCountdownList = ["en", "ja", "ko", "ru", "jp"];
